import React, { useState } from 'react'
import {
  Button,
  HStack,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Text,
  useToast
} from '@chakra-ui/react'
import axios from 'lib/axios'

const RereunRequestModal = ({
  isOpen,
  onClose,
  rentalApplicationId,
  rerunType
}: {
  isOpen: boolean
  onClose: () => void
  rentalApplicationId: string
  rerunType: 'initial' | 'final'
}) => {
  const toast = useToast()
  const [isLoading, setIsLoading] = useState(false)

  const handleRerun = async () => {
    setIsLoading(true)
    try {
      const response = await axios.post(`/admin/saferent/${rentalApplicationId}/rerun`, {
        type: rerunType
      })
      if (response.data.success) {
        toast({
          title: 'Underwriting request rerun',
          description: response.data.message,
          status: 'success',
          duration: 5000,
          isClosable: true,
          position: 'bottom-right'
        })
        onClose()
      } else {
        toast({
          title: 'Error rerunning underwriting request',
          description: response.data.message,
          status: 'error',
          duration: 5000,
          isClosable: true,
          position: 'bottom-right'
        })
      }
    } catch (error: any) {
      toast({
        title: 'Error rerunning underwriting request',
        description:
          error.response?.data?.message || error.message || 'An unexpected error occurred',
        status: 'error',
        duration: 5000,
        isClosable: true,
        position: 'bottom-right'
      })
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          Rerun {rerunType === 'initial' ? 'Initial' : 'Final'} Underwriting Request
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Text>
            Are you sure you want to rerun the {rerunType === 'initial' ? 'initial' : 'final'}{' '}
            underwriting request?
          </Text>
          <Text>
            Note this will take a few minutes to complete. Do not close the page while it is
            running.{' '}
          </Text>
        </ModalBody>
        <ModalFooter>
          <HStack>
            <Button size='xs' variant='ghost' onClick={onClose} isDisabled={isLoading}>
              Cancel
            </Button>
            <Button size='xs' colorScheme='teal' onClick={handleRerun} isLoading={isLoading}>
              Rerun
            </Button>
          </HStack>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}

export default RereunRequestModal
